<template lang="html">
  <div class="tobeadopted">
    <div  v-if="animals.length>0" class="text-center">
      <v-chip
        class="ma-2"
        color="secondary"
        :class="{chipactive: myfilter==='kölyök'}"
        @click="showFilter('kölyök')"
      >
        Kölyök
      </v-chip>
      <v-chip
        class="ma-2"
        color="secondary"
        :class="{chipactive: myfilter==='egyéb'}"
        @click="showFilter('egyéb')"
      >
        Nemkutya védenceink
      </v-chip>
      <v-chip
        class="ma-2"
        color="secondary"
        :class="{chipactive: myfilter==='all'}"
        @click="showFilter('all')"
      >
        Összes örökbefogadható védenc
      </v-chip>
    </div>
    <AnimalList v-if="animals.length>0" :animals="animals" />
    <div class="text-center mt-5" v-else>
      Sajnos nincs örökbeadható védencünk, nézzen vissza később, esetleg látogasson meg minket menhelyünkön!
    </div>
  </div>
</template>

<script>
import AnimalList from '@/components/AnimalList.vue'

export default {
  data(){
    return {
      animals: this.$store.getters.adoptableAnimals,
      myfilter: 'all',
    }
  },
  components:{
    AnimalList,
  },
  methods:{
    showFilter(filterby){
      this.myfilter = filterby;
      if (filterby==='all') {
        this.animals= this.$store.getters.adoptableAnimals
      }
      else if (filterby==='kölyök'){
        this.animals= this.$store.getters.adoptableAnimals.filter(a=>a.puppy==true)
      }
      else if (filterby==='egyéb'){
        this.animals= this.$store.getters.adoptableAnimals.filter(a=>a.species!=="eb")
      }
      else{
        this.animals= this.$store.getters.adoptableAnimals
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-chip.chipactive{
  background: $darkbrown !important;
}
</style>
